import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from "react";
import { ApiError, api } from "./api";
const Ctx = createContext(null);
export function AuthProvider({ children }) {
    const [me, setMe] = useState(null);
    const [loading, setLoading] = useState(true);
    const [needsBootstrap, setNeedsBootstrap] = useState(false);
    async function refresh() {
        try {
            const m = await api.get("/auth/me");
            setMe(m);
            setNeedsBootstrap(false);
        }
        catch (e) {
            setMe(null);
            if (e instanceof ApiError && e.status === 401) {
                try {
                    const status = await api.get("/auth/bootstrap-status");
                    setNeedsBootstrap(status.needs_bootstrap);
                }
                catch {
                    setNeedsBootstrap(false);
                }
            }
        }
        finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        refresh();
    }, []);
    async function login(email, password) {
        await api.post("/auth/login", { email, password });
        await refresh();
    }
    async function register(email, password, fullName) {
        await api.post("/auth/register", { email, password, full_name: fullName });
        await refresh();
    }
    async function logout() {
        await api.post("/auth/logout");
        setMe(null);
    }
    return (_jsx(Ctx.Provider, { value: { me, loading, needsBootstrap, refresh, login, register, logout }, children: children }));
}
export function useAuth() {
    const v = useContext(Ctx);
    if (!v)
        throw new Error("AuthProvider missing");
    return v;
}
